import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import ActivityTitle from './activityTitle';
import CombinedViewFiles from './combinedViewFiles';

/** A file attached to an Activity or one of its notes. */
export default function ActivityFilesTemplate({ data, isPrintPreview }) {
    if (!data.files || data.files.length === 0) {
        return null;
    }
    return (
        <div className="combinedListing detailListing">
            <span className="time_line_bar"></span>
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>
            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                <div className="combinedDescription detailDescription">
                    <div className="alignMiddle mb mb__8 flexWrap">
                        <ActorName userId={data.actor_id} inner="header" />
                        <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                        </span>
                        attached a file to
                        <ActivityTitle activity={data.activity} isPrintPreview={isPrintPreview} />
                    </div>
                    <div className="update_information">
                        <CombinedViewFiles files={data.files} entry={data} isPrintPreview={isPrintPreview} />
                    </div>
                </div>
            </div>
        </div>
    )
}
